import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axiosInstance from "../Services/AxiosAPICaller";

const DEBOUNCE_MS = 2000;

export const usePageTracking = () => {
  const location = useLocation();
  const lastTrackedAt = useRef(0);
  const isFirstRender = useRef(true);

  useEffect(() => {
    // Skip the first render — session start is handled in App.tsx
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const now = Date.now();
    if (now - lastTrackedAt.current < DEBOUNCE_MS) return;
    lastTrackedAt.current = now;

    const visitorId = localStorage.getItem("visitorId");
    if (!visitorId) return;

    axiosInstance
      .post("/visitor-tracking", { visitorId, eventType: "pageview" })
      .catch(() => {});
  }, [location.pathname]);
};
